// tenis.io resmi içerik görselleri (docs/OFFICIAL-CONTENT.md): repoda sabit dosya (`public/images/icerik/`),
// 1080×1080. Yalnız bu listedeki görsel karta yazılır; yeni görsel dosya + satır ekleyip yayınla gelir.
export type OfficialImage = { path: string; alt: string };

export const OFFICIAL_IMAGES: OfficialImage[] = [
  {
    path: '/images/icerik/2026-11-09-cizgi.png',
    alt: 'Çizgiye değen top içeridir: kortta ve çizgiye değen top içeride, çizgiyle arasında boşluk olan top dışarıda.',
  },
  {
    path: '/images/icerik/2026-11-10-ikinci-servis.png',
    alt: 'İkinci servis: hızlı ve düz servis fileye takılır, yavaş ve yüksek yaylı servis servis karesine düşer.',
  },
  {
    path: '/images/icerik/2026-11-11-isinma.png',
    alt: '10 dakikalık ısınma: 2 dakika mini tenis, 3 dakika dipten ralli, 2 dakika vole ve smaç, 3 dakika servis.',
  },
  {
    path: '/images/icerik/2026-11-12-let.png',
    alt: 'Fileye değen servis: servis karesine düşerse let, servis tekrar atılır; kare dışına düşerse hata.',
  },
  {
    path: '/images/icerik/2026-11-13-partner.png',
    alt: 'Partner ara: akışta düğmeye dokun, gün ve saati seç, liginden maç teklifi gelsin.',
  },
  {
    path: '/images/icerik/2026-11-14-capraz.png',
    alt: 'Çapraz vuruş: file ortada 91,4 cm, kenarda 107 cm; çapraz mesafe 25,15 m, düz 23,77 m.',
  },
];

export const officialImage = (value: unknown): OfficialImage | null =>
  OFFICIAL_IMAGES.find(image => image.path === value) || null;
